(function () {
  'use strict';

  const defaults = {
    featureFlags: {
      multiVariantAddPrompt: true,
      multiTargetCustomiserSave: true,
      allowUngroupedCartActions: true,
    },
    prices: {
      embroidery: {
        smallCents: 380,
        largeCents: 720,
      },
      printing: {
        smallCents: 349,
        largeCents: 660,
      },
      digitalisationCents: 1800,
    },
    labels: {
      promptTitle: 'Add logo to these items?',
      promptTextSingle: 'Apply one logo setup to these items now?',
      promptTextMulti: 'You added {{count}} variants. Apply one logo setup to all of them now?',
      promptSkip: 'No thanks',
      promptAdd: 'Add logo',
    },
    pages: {
      fallback: '/pages/add-logo',
      prefix: 'add-logo-',
      map: {
        fleece: '/pages/add-logo-fleece',
      },
    },
    products: {
      byHandle: {},
    },
  };

  const existing = window.NewLogoConfig || {};
  window.NewLogoConfig = {
    ...defaults,
    ...existing,
    featureFlags: {
      ...defaults.featureFlags,
      ...(existing.featureFlags || {}),
    },
    prices: {
      ...defaults.prices,
      ...(existing.prices || {}),
      embroidery: {
        ...defaults.prices.embroidery,
        ...((existing.prices && existing.prices.embroidery) || {}),
      },
      printing: {
        ...defaults.prices.printing,
        ...((existing.prices && existing.prices.printing) || {}),
      },
    },
    labels: {
      ...defaults.labels,
      ...(existing.labels || {}),
    },
    pages: {
      ...defaults.pages,
      ...(existing.pages || {}),
      map: {
        ...defaults.pages.map,
        ...((existing.pages && existing.pages.map) || {}),
      },
    },
    products: {
      ...defaults.products,
      ...(existing.products || {}),
      byHandle: {
        ...defaults.products.byHandle,
        ...((existing.products && existing.products.byHandle) || {}),
      },
    },
  };
})();
